import { render, staticRenderFns } from "./EmployRecommend.vue?vue&type=template&id=f46d0bb2&scoped=true&"
import script from "./EmployRecommend.vue?vue&type=script&lang=js&"
export * from "./EmployRecommend.vue?vue&type=script&lang=js&"
import style0 from "./EmployRecommend.vue?vue&type=style&index=0&id=f46d0bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46d0bb2",
  null
  
)

export default component.exports